import React from 'react'
import styled from 'styled-components'
import GrabAndGo from './components/carousel'
import Grid from './components/grid'
import Header from './components/section-header'

const Block = styled.div`
    margin-bottom: 80px;
`

const ZoomMakerStarters = () => (
    <>
        <Block>
            <Header title="Grab &amp; Go">
                <p>
                    Running late to your Zoom meeting &amp; don&apos;t have time to be creative? Download one of our
                    Grab &amp; Go virtual backgrounds below or head on over to our{' '}
                    <a href="/backdrops" target="_blank" rel="noreferrer">
                        Backdrops Channel
                    </a>
                    .
                </p>
            </Header>
            <GrabAndGo />
        </Block>
        <Block>
            <Header title="Choose a Starter">
                <p>
                    Choose a starter below or search our library to decorate your virtual background with GIFs,
                    stickers, text, &amp; more. Prefer to just download? Click the <i className="ss-download" /> icon on
                    any of the backdrops below.
                </p>
            </Header>
            <Grid />
        </Block>
    </>
)

export default ZoomMakerStarters
